<div class="row mainwrapper">
  <div class="col-lg-3 col-md-3 leftOverview">
    <h5 class="text-right">
      <strong>INVENTORY ESTIMATE</strong>
    </h5>
    <ul class="list-group" *ngIf="!isFreemium">
      <li class="list-group-item" *ngFor="let country of inventoryDistribution?.countries">
        <h5>{{ country.region === 'NA' ? 'North America': country.region }}
        </h5>
        <h5 class="value">{{country.totalInventory | roundsig}}</h5>
      </li>
    </ul>
    <ul class="list-group" *ngIf="isFreemium">
      <li class="list-group-item">
        <h5>North America</h5>
        <h5 class="value">
          <div class="freemium-lock">
            <i class="fa fa-lock"></i>
          </div>
        </h5>
      </li>
      <li class="list-group-item">
        <h5>APAC</h5>
        <h5 class="value">
          <div class="freemium-lock">
            <i class="fa fa-lock"></i>
          </div>
        </h5>
      </li>
      <li class="list-group-item">
        <h5>EMEA</h5>
        <h5 class="value">
          <div class="freemium-lock">
            <i class="fa fa-lock"></i>
          </div>
        </h5>
      </li>
      <li class="list-group-item">
        <h5>LATAM</h5>
        <h5 class="value">
          <div class="freemium-lock">
            <i class="fa fa-lock"></i>
          </div>
        </h5>
      </li>
    </ul>

  </div>
  <div class="col-lg-9 col-md-9 chartContainer">
    <ng-container *ngIf="!isFreemium">
      <div class="row p-1" style="text-align: center; margin-bottom: 30px; margin-top: 10px;">
        <div class="btn-group chartBtn" role="group" aria-label="Region"
          style="position: absolute; height: 30px; right: 0; margin-right: 35px;">
          <button type="button" class="btn btn-sm btn-secondary" [class.disabled]="currentType=='month'"
            (click)="changeChartData('month')">Month
          </button>
          <button type="button" class="btn btn-sm btn-secondary" [class.disabled]="currentType=='day'"
            (click)="changeChartData('day')">Week
          </button>
          <button type="button" class="btn btn-sm btn-secondary" [class.disabled]="currentType=='hour'"
            (click)="changeChartData('hour')">Day
          </button>
        </div>
      </div>
      <app-line-chart [data]="lineChartData" [categoryField]="currentType" [valueFields]="['totalInventory']"
        [dataDateFormat]="'MM-DD-YYYY JJ:NN:SS'" [minPeriod]="currentType === 'day' ? 'DD' : 'hh'"
        [titleArray]="[graphTitle + ' Inventory by ' + (currentType === 'day'? 'WEEK': currentType === 'hour'? 'DAY': 'MONTH') + '  ']">
      </app-line-chart>
    </ng-container>
    <div class="row" *ngIf="inventoryDistribution?.countries?.length > 0">
      <div class="col-lg-12">
        <h4 class="text-uppercase mt-2 p-1">
          Inventory by Region
        </h4>
        <app-data-table-component [headers]="headerCountries" [currentSort]="'totalInventory'"
          [data]="countries"></app-data-table-component>
      </div>
    </div>
    <!-- INVENTORY BY REGIONS -->

    <div class="row" *ngIf="inventoryDistribution?.countriesByRegion?.length > 0">
      <div class="col-lg-12">
        <h4 class="text-uppercase mt-2 p-1">
          Inventory by Country
        </h4>
        <app-data-table-component [headers]="headerCountriesByRegion" [currentSort]="'totalInventory'"
          [data]="countriesByRegion">
        </app-data-table-component>
      </div>
    </div>
    <!-- INVENTORY BY COUNTRIES BY REGION -->

    <div class="row" *ngIf="inventoryDistribution?.regions?.length > 0">
      <div class="col-lg-12">
        <h4 class="text-uppercase mt-2 p-1">
          Inventory by {{ (region!='NON-US')?"State":"Country" }}
        </h4>
        <app-data-table-component [headers]="headerRegions" [currentSort]="'totalInventory'"
          [data]="regions"></app-data-table-component>
      </div>
    </div>
    <!-- INVENTORY BY COUNTRIES BY STATE/COUNTRY -->

    <div class="row" *ngIf="inventoryDistribution?.adSizes?.length > 0">
      <div class="col-lg-12">
        <h4 class="text-uppercase mt-2 p-1">
          Inventory by Ad Size
        </h4>
        <app-data-table-component [headers]="headerAdSizes" [currentSort]="'totalInventory'"
          [data]="adSizes"></app-data-table-component>
      </div>
    </div>
    <!-- INVENTORY BY AD SIZE -->

    <div class="row" *ngIf="inventoryDistribution?.dmas?.length > 0">
      <div class="col-lg-12">
        <h4 class="text-uppercase mt-2 p-1">
          Inventory by DMA
        </h4>
        <app-data-table-component [headers]="headerDmas" [currentSort]="'totalInventory'"
          [data]="dmas"></app-data-table-component>
      </div>
    </div>
    <!-- INVENTORY BY DMA -->

  </div>
</div>

<ng-template #regionTemplate let-item='item' let-row='row'>
  <span>{{ item === 'NA' ? 'North America' : item }}</span>
</ng-template>

<ng-template #usRegionTemplate let-item='item' let-row='row'>
  <span>{{ row?.countryName }}, {{ item }}</span>
</ng-template>